module.exports = __webpack_public_path__ + "img/upload_success.616b069c.gif";